// extracted by mini-css-extract-plugin
export default {"item":"HDkLBy","subItem":"BEgsaf"};